const wookmark = require('./_wookmark.min.js');
const imagesLoaded = require('./_imagesloaded.js');



function runWoookmark(){
	if($('.section--work').hasClass('is--illust--work')){
		$('.grid-item').imagesLoaded(function() {
			$('.grid').wookmark({
				autoResize: true,
				offset: 0
			});
		});
	}
}

module.exports = runWoookmark;



// WEBPACK FOOTER //
// ./es2015/module/_wookmark.js